import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BusyComponent } from './busy.component';
import { ProgressModule } from 'app/shared/progress/progress.module';


@NgModule({
  declarations: [
    BusyComponent
  ],
  imports: [
    CommonModule,
    ProgressModule
  ],
  exports: [BusyComponent]
})
export class BusyModule { }
